import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: `'Trebuchet MS', sans-serif`,
  },
  palette: {
    primary: {
      main: '#6A5AF9',
      dark: '#5A4AE8',
      light: '#7F73EE',
    },
    secondary: {
      main: '#7D73EE',
      dark: '#6D63DE',
      light: '#9A92F2',
    },
    tertiary: {
      main: '#9754AE',
      dark: '#85479A',
      light: '#AE6CC3',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  components: {
    // Tooltips globales: fondo negro, flecha y tipografía legible
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: 'rgba(0, 0, 0, 0.92)',
          fontSize: 12,
        },
        arrow: {
          color: 'rgba(0, 0, 0, 0.92)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 700,
          padding: '10px 22px',
          textTransform: 'none',
          boxShadow: 'none !important',
          '&:hover': {
            boxShadow: 'none !important',
          }
        },
        contained: {
          background: 'linear-gradient(90deg, #6A5AF9 0%, #5A4AE8 100%) !important',
          color: '#ffffff !important',
          '&:hover': {
            background: 'linear-gradient(90deg, #5F50EF 0%, #5344DD 100%) !important',
          },
          '&.Mui-disabled': {
            background: 'rgba(0, 0, 0, 0.12) !important',
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(90deg, #6A5AF9 0%, #5A4AE8 100%) !important',
          '&:hover': {
            background: 'linear-gradient(90deg, #5F50EF 0%, #5344DD 100%) !important',
          },
          '&.Mui-disabled': {
            background: 'rgba(0, 0, 0, 0.12) !important',
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(90deg, #7F73EE 0%, #6D63DE 100%) !important',
          '&:hover': {
            background: 'linear-gradient(90deg, #7368E3 0%, #645ACF 100%) !important',
          },
          '&.Mui-disabled': {
            background: 'rgba(0, 0, 0, 0.12) !important',
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        containedTertiary: {
          background: 'linear-gradient(90deg, #A159B0 0%, #8F4DA1 100%) !important',
          '&:hover': {
            background: 'linear-gradient(90deg, #944FA3 0%, #814493 100%) !important',
          },
          '&.Mui-disabled': {
            background: 'rgba(0, 0, 0, 0.12) !important',
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        containedError: {
          background: 'linear-gradient(90deg, #EF4444 0%, #DC2626 100%) !important',
          color: '#ffffff !important',
          '&:hover': {
            background: 'linear-gradient(90deg, #DC2626 0%, #B91C1C 100%) !important',
          },
          '&.Mui-disabled': {
            background: 'rgba(0, 0, 0, 0.12) !important',
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        outlined: {
          borderColor: '#6A5AF9 !important',
          color: '#6A5AF9 !important',
          '&:hover': {
            borderColor: '#5A4AE8 !important',
            backgroundColor: 'rgba(106, 90, 249, 0.08) !important',
          },
          '&.Mui-disabled': {
            borderColor: 'rgba(0, 0, 0, 0.26) !important',
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        outlinedError: {
          borderColor: '#EF4444 !important',
          color: '#EF4444 !important',
          '&:hover': {
            borderColor: '#DC2626 !important',
            backgroundColor: 'rgba(239, 68, 68, 0.08) !important',
          },
          '&.Mui-disabled': {
            borderColor: 'rgba(0, 0, 0, 0.26) !important',
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        text: {
          color: '#6A5AF9 !important',
          '&:hover': {
            backgroundColor: 'rgba(106, 90, 249, 0.08) !important',
          },
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    // Estilo global de los toggles (p. ej. Simple/Completo del DISC en el ATS,
    // wizard de vacantes, envíos masivos): sin mayúsculas, bordes redondeados y
    // seleccionado en violeta. Un sx local (como el del TopBar) sigue ganando.
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          color: '#6B7280',
          borderColor: '#D1D5DB',
          borderRadius: 8,
          '&:hover': {
            backgroundColor: 'rgba(106, 90, 249, 0.08)',
          },
          '&.Mui-selected': {
            backgroundColor: '#6A5AF9',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#5A4AE8',
            },
          },
        },
      },
    },
  },
});

export default theme;